// CCS-379: the ROTA "Med Status" icon must only appear when medication is
// applicable to a shift. A shift has applicable medication when a medication
// group is assigned to it (medicationGroupId), or when medication/PRN has
// actually been administered. Without this guard, a completed shift with no
// medication showed a red "no medications administered" indicator, which reads
// as a missed dose even though medication was never relevant to that shift.
export const isMedicationApplicable = (shift = {}) => {
  const groupId = shift.medicationGroupId;
  const hasGroup =
    typeof groupId === "string" ? groupId.trim() !== "" : Boolean(groupId);
  return (
    hasGroup ||
    Boolean(shift.hasMedicationsAdministered) ||
    Boolean(shift.hasPrnAdministered)
  );
};
